import { TabPane } from "reactstrap";
import CommonTabContentTable from "./CommonTabContentTable";

const FourTabContent = () => {
  return (
    <TabPane tabId="4">
      <div className="custom-scrollbar">
        <CommonTabContentTable value={4}/>
      </div>
    </TabPane>
  );
};

export default FourTabContent;
